import React from 'react'
import { Tag } from 'antd'
import './StatusTag.css'

export interface StatusTagProps {
  status?: 'success' | 'processing' | 'warning' | 'error' | 'default' | string
  text: string
  color?: string
  glow?: boolean
  className?: string
}

const COLOR_MAP: Record<string, { bg: string; color: string; border: string; dot: string }> = {
  success: {
    bg: 'rgba(46, 204, 113, 0.12)',
    color: '#2ecc71',
    border: 'rgba(46, 204, 113, 0.3)',
    dot: '#2ecc71',
  },
  processing: {
    bg: 'rgba(0, 225, 255, 0.12)',
    color: '#00e1ff',
    border: 'rgba(0, 225, 255, 0.3)',
    dot: '#00e1ff',
  },
  warning: {
    bg: 'rgba(255, 182, 39, 0.12)',
    color: '#ffb627',
    border: 'rgba(255, 182, 39, 0.3)',
    dot: '#ffb627',
  },
  error: {
    bg: 'rgba(255, 62, 77, 0.12)',
    color: '#ff3e4d',
    border: 'rgba(255, 62, 77, 0.3)',
    dot: '#ff3e4d',
  },
  default: {
    bg: 'rgba(255, 255, 255, 0.06)',
    color: '#9fa2b8',
    border: 'rgba(255, 255, 255, 0.12)',
    dot: '#6b6f85',
  },
}

export const StatusTag: React.FC<StatusTagProps> = ({
  status = 'default',
  text,
  color,
  glow = true,
  className = '',
}) => {
  const scheme = COLOR_MAP[status] || COLOR_MAP.default

  return (
    <Tag
      className={`admin-status-tag cstore-status-tag ${glow ? 'has-glow' : ''} ${className}`}
      style={{
        backgroundColor: scheme.bg,
        color: color || scheme.color,
        borderColor: scheme.border,
      }}
    >
      <span className="status-dot" style={{ backgroundColor: scheme.dot }} />
      {text}
    </Tag>
  )
}

export default StatusTag
